var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: (newValue) => all[name] = () => newValue
    });
};

// packages/core/src/academicYears.ts
var ACADEMIC_YEARS = {
  FRESHMAN: 0,
  REDSHIRT_FRESHMAN: 10,
  SOPHOMORE: 20,
  REDSHIRT_SOPHOMORE: 30,
  JUNIOR: 40,
  REDSHIRT_JUNIOR: 50,
  SENIOR: 60,
  REDSHIRT_SENIOR: 70,
  GRADUATE_STUDENT: 80
};
// packages/core/src/agreements.ts
var AGREEMENT_STATUSES = {
  PROPOSED: 0,
  DECLINED: 1,
  APPROVED: 2,
  EXPIRED: 3,
  ARCHIVED: 4
};
// packages/core/src/api/apiV1.ts
var exports_apiV1 = {};
__export(exports_apiV1, {
  COMPLIANCE_TRANSACTIONS_LEADER_TYPES: () => COMPLIANCE_TRANSACTIONS_LEADER_TYPES
});

// packages/core/src/api/v1/complianceTransactions.ts
var COMPLIANCE_TRANSACTIONS_LEADER_TYPES = [
  "brand",
  "athlete",
  "team"
];
// packages/core/src/api/apiV2.ts
var exports_apiV2 = {};
// packages/core/src/api/utilities/provider.ts
var PER_PAGE_OPTIONS = [25, 50, 100, 250];
// packages/core/src/api/utilities/response.ts
var inflcrErrorCodes = [
  "access_user_already_confirmed",
  "access_user_confirmation_code_is_expired",
  "access_user_not_confirmed",
  "access_user_deactivated",
  "access_unknown_error",
  "access_invalid_user",
  "access_invalid_sso_user",
  "access_user_has_no_profiles",
  "access_user_profile_context_required",
  "content_provider_error",
  "delete_failed",
  "gallery_cannot_be_both_public_and_publicly_tagged",
  "invalid_state_transition",
  "media_not_added",
  "provider_token_is_expired",
  "update_failed",
  "payment_gateway_resource_already_exists",
  "exchange_brand_cannot_create_new_bulletin",
  "existing_conflict",
  "exchange_bulletin_applicant_limit_reached",
  "default"
];
// packages/core/src/attestations.ts
var ATTESTATION_TYPES = {
  HEADING: 1,
  CHECKBOX: 2,
  LINK: 3
};
// packages/core/src/brandStrategies.ts
var BRAND_STRATEGY_CATEGORIES = {
  ATHLETE_MONETIZATION: 1,
  INFLCR_EXCHANGE: 2,
  SOCIAL_MEDIA: 3,
  COLLEGIATE_COMPLIANCE: 4,
  BRAND_BUILDING: 5,
  BUSINESS_FINANCE: 6,
  OTHER: 7
};
// packages/core/src/bulletins.ts
var BULLETIN_CATEGORIES = {
  BRAND_AMBASSADOR: 1,
  CHARITY: 2,
  COLLECTIVE_OPT_IN: 3,
  CONTENT_CREATION: 4,
  DIGITAL_ASSETS: 5,
  EMPLOYMENT_INTERNSHIPS: 6,
  GENERAL: 7,
  GROUP_LICENSING: 8,
  MERCHANDISE_AUTOGRAPHS: 9,
  PUBLIC_APPEARANCE: 10,
  EVENT_EXPERIENCE: 11,
  EARNED_MEDIA: 12,
  ENTERTAINMENT: 13,
  INFLUENCER: 14,
  IN_MARKET_APPEARANCE: 15,
  NASCAR_CONTENT: 16,
  FOUNDATION_HOF: 17,
  INDUSTRY_EVENT: 18,
  BROADCAST: 19,
  PARTNERSHIP: 20,
  IMPACT: 21,
  BRAND: 22,
  DRIVER_SUBMISSION: 23
};
var LEADERBOARD_ONLY_BULLETIN_CATEGORY_IDS = [
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23
];
var BULLETIN_TYPES = {
  INFORMATIONAL: 1,
  OFFER: 2
};
// packages/core/src/comments.ts
var COMMENT_VISIBILITY_OPTIONS = {
  PUBLIC: 0,
  COMPLIANCE_ONLY: 1,
  COMPLIANCE_AND_ATHLETE: 2
};
// packages/core/src/contracts.ts
var CONTRACT_STATUSES = {
  PENDING: 0,
  CREATING: 1,
  CREATED: 2,
  CREATE_FAILED: 3,
  SIGNED: 4,
  CANCELED: 5,
  CERTIFIED: 6,
  CERTIFY_FAILED: 7,
  EXPIRED: 10
};
// packages/core/src/countries.ts
var COUNTRY_CODES = [
  "AD",
  "AF",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "EU",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "USG",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "WSH",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
// packages/core/src/exchangeBrands.ts
var EXCHANGE_BRAND_USER_TYPES = {
  BASE: 0,
  EXCHANGE_ADMIN: 255
};
var EXCHANGE_BRAND_ENTITY_TYPES = {
  BUSINESS: 0,
  INDIVIDUAL: 1
};
var EXCHANGE_BRAND_SCHOOL_STATUSES = {
  PENDING: 0,
  VERIFIED: 1,
  DENIED: 2
};
// packages/core/src/featureFlags.ts
var FEATURE_FLAGS = {
  AGREEMENTS_V2: "agreements-v-2",
  WALLET_BETA: "wallet-beta",
  CONTENT_TASKS: "content-tasks",
  V2_TEAM_MANAGEMENT_MENU_ITEM: "v-2-team-management-menu-item"
};
// packages/core/src/galleries.ts
var GALLERY_STATUSES = {
  PRIVATE: 1,
  PUBLIC: 2
};
var GALLERY_CATEGORIES = {
  PRE_GAME: 1,
  IN_GAME: 2,
  POST_GAME: 3,
  PRACTICE: 4,
  TRAVEL: 5,
  PRESS_CONFERENCE: 6,
  OTHER: 7,
  COMMUNITY_EVENT: 8,
  SPECIAL_EVENT: 9,
  MEETING: 10
};
// packages/core/src/integrationProviders.ts
var INTEGRATION_PROVIDER_KEYS = {
  PHOTOSHELTER: "photoshelter-v4",
  SMUGMUG: "smugmug-v2",
  BOX: "box",
  DROPBOX: "dropbox",
  GOOGLE_DRIVE: "google",
  GETTY_IMAGES: "gettyimages",
  IMAGN: "imagn",
  WSC_SPORTS: "wsc-sports"
};
// packages/core/src/interests.ts
var INTERESTS = {
  ACTING: 1,
  CHARITY: 2,
  COACHING: 3,
  CONTENT_CREATION: 4,
  CRYPTO: 5,
  FASHION: 6,
  FITNESS: 7,
  FOOD: 8,
  MOVIES: 9,
  MUSIC: 10,
  PHOTOGRAPHY: 11,
  TRAVEL: 12,
  TV_SHOWS: 13,
  VIDEO_GAMES: 14,
  MILITARY: 15
};
// packages/core/src/majors.ts
var MAJORS = {
  ACCOUNTING: 1,
  ACTUARIAL_SCIENCE: 2,
  ADVERTISING: 3,
  AEROSPACE_ENGINEERING: 4,
  AFRICAN_AMERICAN_STUDIES: 7,
  AFRICAN_LANGUAGES_LITERATURES_AND_LINGUISTICS: 5,
  AFRICAN_STUDIES: 6,
  AGRICULTURAL_BUSINESS_AND_MANAGEMENT: 8,
  AGRICULTURAL_ECONOMICS: 9,
  AGRICULTURAL_EDUCATION: 10,
  AGRICULTURAL_JOURNALISM: 11,
  AGRICULTURAL_MECHANIZATION: 12,
  AGRICULTURAL_TECHNOLOGY_MANAGEMENT: 13,
  AGRICULTURAL_BIOLOGICAL_ENGINEERING_AND_BIOENGINEERING: 14,
  AGRICULTURE: 15,
  AGRONOMY_AND_CROP_SCIENCE: 16,
  AIR_TRAFFIC_CONTROL: 17,
  AMERICAN_HISTORY: 18,
  AMERICAN_LITERATURE: 19,
  AMERICAN_SIGN_LANGUAGE: 20,
  AMERICAN_STUDIES: 21,
  ANATOMY: 22,
  ANCIENT_STUDIES: 23,
  ANIMAL_BEHAVIOR_AND_ETHOLOGY: 24,
  ANIMAL_SCIENCE: 25,
  ANIMATION_AND_SPECIAL_EFFECTS: 26,
  ANTHROPOLOGY: 27,
  APPLIED_MATHEMATICS: 28,
  AQUACULTURE: 29,
  AQUATIC_BIOLOGY: 30,
  ARABIC: 31,
  ARCHEOLOGY: 32,
  ARCHITECTURAL_ENGINEERING: 33,
  ARCHITECTURAL_HISTORY: 34,
  ARCHITECTURE: 35,
  ART: 36,
  ART_EDUCATION: 37,
  ART_HISTORY: 38,
  ART_THERAPY: 39,
  ARTIFICIAL_INTELLIGENCE_AND_ROBOTICS: 40,
  ASIAN_AMERICAN_STUDIES: 41,
  ASTRONOMY: 42,
  ASTROPHYSICS: 43,
  ATHLETIC_TRAINING: 44,
  ATMOSPHERIC_SCIENCE: 45,
  AUTOMOTIVE_ENGINEERING: 46,
  AVIATION: 47,
  BAKERY_SCIENCE: 48,
  BIBLICAL_STUDIES: 49,
  BIOCHEMISTRY: 50,
  BIOETHICS: 51,
  BIOLOGY: 52,
  BIOMEDICAL_ENGINEERING: 53,
  BIOMEDICAL_SCIENCE: 54,
  BIOPSYCHOLOGY: 55,
  BIOTECHNOLOGY: 56,
  BOTANY_PLANT_BIOLOGY: 57,
  BUSINESS_ADMINISTRATION_MANAGEMENT: 58,
  BUSINESS_COMMUNICATIONS: 59,
  BUSINESS_EDUCATION: 60,
  CANADIAN_STUDIES: 61,
  CARIBBEAN_STUDIES: 62,
  CELL_BIOLOGY: 63,
  CERAMIC_ENGINEERING: 64,
  CERAMICS: 65,
  CHEMICAL_ENGINEERING: 66,
  CHEMICAL_PHYSICS: 67,
  CHEMISTRY: 68,
  CHILD_CARE: 69,
  CHILD_DEVELOPMENT: 70,
  CHINESE: 71,
  CHIROPRACTIC: 72,
  CHURCH_MUSIC: 73,
  CINEMATOGRAPHY_AND_FILM_VIDEO_PRODUCTION: 74,
  CIRCULATION_TECHNOLOGY: 75,
  CIVIL_ENGINEERING: 76,
  CLASSICS: 77,
  CLINICAL_PSYCHOLOGY: 78,
  COGNITIVE_PSYCHOLOGY: 79,
  COMMUNICATION_DISORDERS: 80,
  COMMUNICATIONS_STUDIESSPEECH_COMMUNICATION_AND_RHETORIC: 81,
  COMPARATIVE_LITERATURE: 82,
  COMPUTER_AND_INFORMATION_SCIENCE: 83,
  COMPUTER_ENGINEERING: 84,
  COMPUTER_GRAPHICS: 85,
  COMPUTER_SYSTEMS_ANALYSIS: 86,
  CONSTRUCTION_MANAGEMENT: 87,
  COUNSELING: 88,
  CRAFTS: 89,
  CREATIVE_WRITING: 90,
  CRIMINAL_SCIENCE: 91,
  CRIMINOLOGY: 92,
  CULINARY_ARTS: 93,
  DANCE: 94,
  DATA_PROCESSING: 95,
  DENTAL_HYGIENE: 96,
  DEVELOPMENTAL_PSYCHOLOGY: 97,
  DIAGNOSTIC_MEDICAL_SONOGRAPHY: 98,
  DIETETICS: 99,
  DIGITAL_COMMUNICATIONS_AND_MEDIAMULTIMEDIA: 100,
  DRAWING: 101,
  EARLY_CHILDHOOD_EDUCATION: 102,
  EAST_ASIAN_STUDIES: 103,
  EAST_EUROPEAN_STUDIES: 104,
  ECOLOGY: 105,
  ECONOMICS: 106,
  EDUCATION: 107,
  EDUCATION_ADMINISTRATION: 108,
  EDUCATION_OF_THE_DEAF: 109,
  EDUCATIONAL_PSYCHOLOGY: 110,
  ELECTRICAL_ENGINEERING: 111,
  ELEMENTARY_EDUCATION: 112,
  ENGINEERING_MECHANICS: 113,
  ENGINEERING_PHYSICS: 114,
  ENGLISH: 115,
  ENGLISH_COMPOSITION: 116,
  ENGLISH_LITERATURE: 117,
  ENTOMOLOGY: 118,
  ENTREPRENEURSHIP: 119,
  ENVIRONMENTAL_DESIGNARCHITECTURE: 120,
  ENVIRONMENTAL_SCIENCE: 121,
  ENVIRONMENTAL_ENVIRONMENTAL_HEALTH_ENGINEERING: 122,
  EPIDEMIOLOGY: 123,
  EQUINE_STUDIES: 124,
  ETHNIC_STUDIES: 125,
  EUROPEAN_HISTORY: 126,
  EXPERIMENTAL_PATHOLOGY: 127,
  EXPERIMENTAL_PSYCHOLOGY: 128,
  FASHION_DESIGN: 129,
  FASHION_MERCHANDISING: 130,
  FEED_SCIENCE: 131,
  FIBER_TEXTILES_AND_WEAVING_ARTS: 132,
  FILM: 133,
  FINANCE: 134,
  FLORICULTURE: 135,
  FOOD_SCIENCE: 136,
  FORENSIC_SCIENCE: 137,
  FORESTRY: 138,
  FRENCH: 139,
  FURNITURE_DESIGN: 140,
  GAME_DESIGN: 141,
  GAY_AND_LESBIAN_STUDIES: 142,
  GENETICS: 143,
  GEOGRAPHY: 144,
  GEOLOGICAL_ENGINEERING: 145,
  GEOLOGY: 146,
  GEOPHYSICS: 147,
  GERMAN: 148,
  GERONTOLOGY: 149,
  GOVERNMENT: 150,
  GRAPHIC_DESIGN: 151,
  HEALTH_ADMINISTRATION: 152,
  HEBREW: 153,
  HISPANIC_AMERICAN_PUERTO_RICAN_AND_CHICANO_STUDIES: 154,
  HISTORIC_PRESERVATION: 155,
  HISTORY: 156,
  HOME_ECONOMICS: 157,
  HORTICULTURE: 158,
  HOSPITALITY: 159,
  HUMAN_DEVELOPMENT: 160,
  HUMAN_RESOURCES_MANAGEMENT: 161,
  ILLUSTRATION: 162,
  INDUSTRIAL_DESIGN: 163,
  INDUSTRIAL_ENGINEERING: 164,
  INDUSTRIAL_MANAGEMENT: 165,
  INDUSTRIAL_PSYCHOLOGY: 166,
  INFORMATION_TECHNOLOGY: 167,
  INTERIOR_ARCHITECTURE: 168,
  INTERIOR_DESIGN: 169,
  INTERNATIONAL_AGRICULTURE: 170,
  INTERNATIONAL_BUSINESS: 171,
  INTERNATIONAL_RELATIONS: 172,
  INTERNATIONAL_STUDIES: 173,
  ISLAMIC_STUDIES: 174,
  ITALIAN: 175,
  JAPANESE: 176,
  JAZZ_STUDIES: 177,
  JEWELRY_AND_METALSMITHING: 178,
  JEWISH_STUDIES: 179,
  JOURNALISM: 180,
  KINESIOLOGY: 181,
  KOREAN: 182,
  LAND_USE_PLANNING_AND_MANAGEMENT: 183,
  LANDSCAPE_ARCHITECTURE: 184,
  LANDSCAPE_HORTICULTURE: 185,
  LATIN_AMERICAN_STUDIES: 186,
  LIBRARY_SCIENCE: 187,
  LINGUISTICS: 188,
  LOGISTICS_MANAGEMENT: 189,
  MANAGEMENT_INFORMATION_SYSTEMS: 190,
  MANAGERIAL_ECONOMICS: 191,
  MARINE_BIOLOGY: 192,
  MARINE_SCIENCE: 193,
  MARKETING: 194,
  MASS_COMMUNICATION: 195,
  MASSAGE_THERAPY: 196,
  MATERIALS_SCIENCE: 197,
  MATHEMATICS: 198,
  MECHANICAL_ENGINEERING: 199,
  MEDICAL_TECHNOLOGY: 200,
  MEDIEVAL_AND_RENAISSANCE_STUDIES: 201,
  MENTAL_HEALTH_SERVICES: 202,
  MERCHANDISING_AND_BUYING_OPERATIONS: 203,
  METALLURGICAL_ENGINEERING: 204,
  MICROBIOLOGY: 205,
  MIDDLE_EASTERN_STUDIES: 206,
  MILITARY_SCIENCE: 207,
  MINERAL_ENGINEERING: 208,
  MISSIONS: 209,
  MODERN_GREEK: 210,
  MOLECULAR_BIOLOGY: 211,
  MOLECULAR_GENETICS: 212,
  MORTUARY_SCIENCE: 213,
  MUSEUM_STUDIES: 214,
  MUSIC: 215,
  MUSIC_EDUCATION: 216,
  MUSIC_HISTORY: 217,
  MUSIC_MANAGEMENT: 218,
  MUSIC_THERAPY: 219,
  MUSICAL_THEATER: 220,
  NATIVE_AMERICAN_STUDIES: 221,
  NATURAL_RESOURCES_CONSERVATION: 222,
  NAVAL_ARCHITECTURE: 223,
  NEUROBIOLOGY: 224,
  NEUROSCIENCE: 225,
  NUCLEAR_ENGINEERING: 226,
  NURSING: 227,
  NUTRITION: 228,
  OCCUPATIONAL_THERAPY: 229,
  OCEAN_ENGINEERING: 230,
  OCEANOGRAPHY: 231,
  OPERATIONS_MANAGEMENT: 232,
  ORGANIZATIONAL_BEHAVIOR_STUDIES: 233,
  PAINTING: 234,
  PALEONTOLOGY: 235,
  PASTORAL_STUDIES: 236,
  PEACE_STUDIES: 237,
  PETROLEUM_ENGINEERING: 238,
  PHARMACOLOGY: 239,
  PHARMACY: 240,
  PHILOSOPHY: 241,
  PHOTOGRAPHY: 242,
  PHOTOJOURNALISM: 243,
  PHYSICAL_EDUCATION: 244,
  PHYSICAL_THERAPY: 245,
  PHYSICIAN_ASSISTANT: 246,
  PHYSICS: 247,
  PHYSIOLOGICAL_PSYCHOLOGY: 248,
  PIANO: 249,
  PLANETARY_SCIENCE: 250,
  PLANT_PATHOLOGY: 251,
  PLAYWRITING_AND_SCREENWRITING: 252,
  POLITICAL_COMMUNICATION: 253,
  POLITICAL_SCIENCE: 254,
  PORTUGUESE: 255,
  PRE_DENTISTRY: 256,
  PRE_LAW: 257,
  PRE_MEDICINE: 258,
  PRE_OPTOMETRY: 259,
  PRE_SEMINARY: 260,
  PRE_VETERINARY_MEDICINE: 261,
  PRINTMAKING: 262,
  PSYCHOLOGY: 263,
  PUBLIC_ADMINISTRATION: 264,
  PUBLIC_HEALTH: 265,
  PUBLIC_POLICY_ANALYSIS: 266,
  PUBLIC_RELATIONS: 267,
  RADIO_AND_TELEVISION: 268,
  RADIOLOGIC_TECHNOLOGY: 269,
  RANGE_SCIENCE_AND_MANAGEMENT: 270,
  REAL_ESTATE_REAL_ESTATE_RR_TS_TECHNOLOGY: 271,
  RECREATION_MANAGEMENT: 272,
  REHABILITATION_SERVICES: 273,
  RELIGIOUS_STUDIES: 274,
  RESPIRATORY_THERAPY: 275,
  RISK_MANAGEMENT: 276,
  RURAL_SOCIOLOGY: 277,
  RUSSIAN: 278,
  SCANDINAVIAN_STUDIES: 279,
  SCULPTURE: 280,
  SLAVIC_LANGUAGES_AND_LITERATURES: 281,
  SOCIAL_PSYCHOLOGY: 282,
  SOCIAL_WORK: 283,
  SOCIOLOGY: 284,
  SOIL_SCIENCE: 285,
  SOUND_ENGINEERING: 286,
  SOUTH_ASIAN_STUDIES: 287,
  SOUTHEAST_ASIA_STUDIES: 288,
  SPANISH: 289,
  SPECIAL_EDUCATION: 290,
  SPEECH_PATHOLOGY: 291,
  SPORT_AND_LEISURE_STUDIES: 292,
  SPORTS_MANAGEMENT: 293,
  STATISTICS: 294,
  SURVEYING: 295,
  SUSTAINABLE_RESOURCE_MANAGEMENT: 296,
  TEACHER_EDUCATION: 297,
  TEACHING_ENGLISH_AS_A_SECOND_LANGUAGE: 298,
  TECHNICAL_WRITING: 299,
  TECHNOLOGY_EDUCATION: 300,
  TEXTILE_ENGINEERING: 301,
  THEATRE: 302,
  THEOLOGY: 303,
  TOURISM: 304,
  TOXICOLOGY: 305,
  TURFGRASS_SCIENCE: 306,
  URBAN_PLANNING: 307,
  URBAN_STUDIES: 308,
  VISUAL_COMMUNICATION: 309,
  VOICE: 310,
  WEB_DESIGN: 311,
  WEBMASTER_AND_WEB_MANAGEMENT: 312,
  WELDING_ENGINEERING: 313,
  WILDLIFE_MANAGEMENT: 314,
  WOMENS_STUDIES: 315,
  YOUTH_MINISTRIES: 316,
  ZOOLOGY: 317
};
// packages/core/src/media.ts
var TAG_TYPES = {
  PROVIDER_DATA: 1,
  FILE_DATA: 2,
  FILE_NAME: 3,
  AI_FACE_MATCH: 4,
  AI_JERSEY_NUMBER: 5,
  MANUAL: 6,
  AI_LOGO_DETECTION: 7
};
var TAG_STATUSES = {
  UNTAGGED: 0,
  TAGGED: 1
};
var MEDIA_FILE_TYPES = [
  "pdf",
  "image",
  "video",
  "audio",
  "other",
  "folder"
];
var MEDIA_ACTIVITY_TYPES = [
  "view",
  "share",
  "download",
  "share_click",
  "tagged",
  "like",
  "dislike"
];
var MEDIA_MODEL_TYPES = [
  "task",
  "transaction_task",
  "gallery",
  "exchange_brand",
  "opportunity",
  "team",
  "school",
  "request",
  "athlete_request",
  "campaign",
  "agreement",
  "transaction"
];
// packages/core/src/mediaRequests.ts
var MEDIA_REQUEST_PURPOSE_TYPES = {
  REQUEST: 0,
  CAMPAIGN: 1
};
var MEDIA_REQUEST_ATHLETE_STATUSES = {
  NOTIFIED: 1,
  DOWNLOADED: 2,
  SHARED: 3,
  COMPLETED: 4
};
// packages/core/src/operators.ts
var OPERATORS = {
  EQUAL: "=",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  GREATER_THAN_OR_EQUAL: ">=",
  LESS_THAN_OR_EQUAL: "<="
};
// packages/core/src/paymentMethods.ts
var PAYMENT_GATEWAYS = {
  STRIPE: 0,
  PAYPAL: 1,
  WALLET: 2
};
var STRIPE_PAYMENT_METHOD_PAYMENT_TYPES = {
  CARD: "card",
  ACH: "ach"
};
var STRIPE_ONBOARDING_STATUSES = {
  NOT_ONBOARDED: 0,
  COMPLETE: 1,
  NEW_REQUIREMENTS: 2
};
var VERIFIED_PAYMENT_METHOD_STATUSES = {
  PENDING: 0,
  TRY_AGAIN: 20,
  FAILED: 30,
  VERIFIED: 50
};
var WALLET_ACCOUNT_TYPES = {
  CASH: "CASH",
  EARN: "EARN",
  EXTERNAL: "EXTERNAL",
  TAX_RESERVES: "TAX_RESERVES",
  TPA_PENDING: "TPA_PENDING"
};
var WALLET_ONBOARDING_STATUSES = {
  PENDING_VERIFICATION: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
  MANUAL_REVIEW: 3,
  UNVERIFIED: 4
};
// packages/core/src/users.ts
var ROLES = {
  SUPER_ADMINISTRATOR: 1,
  ADMINISTRATOR: 2,
  CLIENT_SUCCESS: 3,
  TEAM_USER: 4,
  COMPLIANCE_OFFICER: 5,
  AGENT: 6,
  BRAND_USER: 7
};
var PERMISSIONS = {
  TEAM_ADMIN: 2,
  TEAM_CONTENT_HUB_READ: 3,
  TEAM_CONTENT_HUB_WRITE: 4,
  TEAM_DASHBOARD_READ: 5,
  TEAM_SOCIAL_CHANNELS_READ: 6,
  TEAM_SOCIAL_CHANNELS_WRITE: 7,
  TEAM_SOCIAL_FEED_READ: 8,
  TEAM_NOTIFICATIONS_READ: 9,
  TEAM_NOTIFICATIONS_WRITE: 10,
  ATHLETE_PROFILE_READ: 11,
  ATHLETE_PROFILE_WRITE: 12,
  TEAM_CONTENT_HUB_MEDIA_TAGGED_ONLY_READ: 13,
  TEAM_MESSAGING_READ: 14,
  TEAM_CAMPAIGN_READ: 15,
  TEAM_CAMPAIGN_WRITE: 16,
  MEDIA_REQUEST_READ: 17,
  MEDIA_REQUEST_WRITE: 18,
  TEAM_PROVIDER_READ: 19,
  OPPORTUNITIES_READ: 20,
  OPPORTUNITIES_WRITE: 21,
  TRANSACTIONS_READ: 22,
  TRANSACTIONS_WRITE: 23,
  FMV_VIEW: 24,
  LEADERBOARD_READ: 25,
  LEADERBOARD_WRITE: 26,
  SERVICE_PROVIDER_READ: 27,
  TRANSACTIONS_IMPORT_WRITE: 28
};
var AGENT_DISALLOWED_PERMISSIONS = [
  PERMISSIONS.TEAM_ADMIN,
  PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
  PERMISSIONS.TEAM_CAMPAIGN_READ,
  PERMISSIONS.TEAM_CAMPAIGN_WRITE,
  PERMISSIONS.MEDIA_REQUEST_READ,
  PERMISSIONS.MEDIA_REQUEST_WRITE,
  PERMISSIONS.OPPORTUNITIES_WRITE,
  PERMISSIONS.LEADERBOARD_WRITE,
  PERMISSIONS.TRANSACTIONS_IMPORT_WRITE
];
var APP_SWITCHER_SLUGS = {
  AMS: "ams",
  ARMS: "arms",
  ACADEMICS: "academics",
  CAMPS: "camps",
  COACHING: "coaching",
  COLLECTIVES: "collectives",
  COMMUNITIES: "communities",
  GM: "gm",
  HUB: "hub",
  INFLCR: "inflcr",
  INVENTORY: "inventory",
  NUTRITION: "nutrition",
  PATHWAYS: "pathways",
  PULSE: "pulse",
  STRENGTH: "strength",
  NOTEMEAL: "notemeal",
  RETAIN: "retain",
  SCOUTING: "scouting",
  SMARTABASE: "smartabase",
  WHISTLE: "whistle"
};

// packages/core/src/permissions/permissionRules.ts
var invertMap = (obj) => new Map(Object.entries(obj).map(([k, v]) => [v, k]));
var roleMap = invertMap(ROLES);
var permissionMap = invertMap(PERMISSIONS);
var brandUserTypeMap = invertMap(EXCHANGE_BRAND_USER_TYPES);
var brandEntityTypeMap = invertMap(EXCHANGE_BRAND_ENTITY_TYPES);
var getRoleStr = (role) => roleMap.get(role) ?? "UNKNOWN";
var getPermissionStr = (permission) => permissionMap.get(permission) ?? "UNKNOWN";
var getBrandUserTypeStr = (userType) => brandUserTypeMap.get(userType) ?? "UNKNOWN";
var getBrandEntityTypeStr = (entityType) => brandEntityTypeMap.get(entityType) ?? "UNKNOWN";
var PermissionRules = {
  hasRole: (role) => ({
    check: (profile) => profile.role_id === role,
    errorMessage: `Requires role: ${getRoleStr(role)}`
  }),
  hasAnyRole: (roles) => ({
    check: (profile) => roles.includes(profile.role_id),
    errorMessage: `Requires one of roles: ${roles.map(getRoleStr).join(", ")}`
  }),
  hasTeamPermission: (permission) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.TEAM_USER) {
        return false;
      }
      const permissions = profile.academic_profile.group.permissions.map((p) => p.id);
      return permissions.includes(permission);
    },
    errorMessage: `Requires permission: ${getPermissionStr(permission)}`
  }),
  hasAllTeamPermissions: (permissions) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.TEAM_USER) {
        return false;
      }
      const profilePermissions = profile.academic_profile.group.permissions.map((p) => p.id);
      return permissions.every((p) => profilePermissions.includes(p));
    },
    errorMessage: `Requires all permissions: ${permissions.map(getPermissionStr).join(", ")}`
  }),
  hasAnyTeamPermission: (permissions) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.TEAM_USER) {
        return false;
      }
      const profilePermissions = profile.academic_profile.group.permissions.map((p) => p.id);
      return permissions.some((p) => profilePermissions.includes(p));
    },
    errorMessage: `Requires any of permissions: ${permissions.map(getPermissionStr).join(", ")}`
  }),
  hasAgentPermission: (permission) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.AGENT) {
        return false;
      }
      if (AGENT_DISALLOWED_PERMISSIONS.includes(permission)) {
        return false;
      }
      const permissions = profile.athlete.academic_profile.group.permissions.map((p) => p.id);
      return permissions.includes(permission);
    },
    errorMessage: `Requires permission: ${getPermissionStr(permission)}`
  }),
  hasAllAgentPermissions: (permissions) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.AGENT) {
        return false;
      }
      const profilePermissions = profile.athlete.academic_profile.group.permissions.map((p) => p.id);
      return permissions.every((p) => {
        if (AGENT_DISALLOWED_PERMISSIONS.includes(p))
          return false;
        return profilePermissions.includes(p);
      });
    },
    errorMessage: `Requires all permissions: ${permissions.map(getPermissionStr).join(", ")}`
  }),
  hasAnyAgentPermission: (permissions) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.AGENT) {
        return false;
      }
      const profilePermissions = profile.athlete.academic_profile.group.permissions.map((p) => p.id);
      return permissions.some((p) => {
        if (AGENT_DISALLOWED_PERMISSIONS.includes(p))
          return false;
        return profilePermissions.includes(p);
      });
    },
    errorMessage: `Requires any of permissions: ${permissions.map(getPermissionStr).join(", ")}`
  }),
  isBrandUserType: (brandUserType) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.BRAND_USER) {
        return false;
      }
      return profile.exchange_brand_user_type === brandUserType;
    },
    errorMessage: `Requires brand user type: ${getBrandUserTypeStr(brandUserType)}`
  }),
  isBrandEntityType: (entityType) => ({
    check: (profile) => {
      if (profile.role_id !== ROLES.BRAND_USER) {
        return false;
      }
      return profile.exchange_brand.entity_type === entityType;
    },
    errorMessage: `Requires brand entity type: ${getBrandEntityTypeStr(entityType)}`
  }),
  and: (...rules) => ({
    check: (profile) => rules.every((rule) => rule.check(profile)),
    errorMessage: `(${rules.map((r) => r.errorMessage).join(" AND ")})`
  }),
  or: (...rules) => ({
    check: (profile) => rules.some((rule) => rule.check(profile)),
    errorMessage: `(${rules.map((r) => r.errorMessage).join(" OR ")})`
  }),
  custom: (check, errorMessage) => ({
    check,
    errorMessage: errorMessage || "Does not meet permission requirements"
  })
};
// packages/core/src/serviceProviders.ts
var SERVICE_PROVIDER_FEE_TYPES = [
  "fixed-cost",
  "hourly",
  "negotiated",
  "percent-of-deals"
];
var SERVICE_PROVIDER_CATEGORIES = [
  "brand-business",
  "business-consultant",
  "collective",
  "financial-advisor",
  "legal-services",
  "marketing-agent",
  "other",
  "platform-product",
  "tax-advisor"
];
// packages/core/src/socialMedia.ts
var SOCIAL_MEDIA_PLATFORM_IDS = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  TWITTER: 3,
  TIKTOK: 7,
  LINKEDIN: 8
};
// packages/core/src/sports.ts
var SPORTS = {
  BASEBALL: 1,
  BASKETBALL_MENS: 2,
  BASKETBALL_WOMENS: 3,
  CROSS_COUNTRY_MENS: 4,
  CROSS_COUNTRY_WOMENS: 5,
  FIELD_HOCKEY: 6,
  FOOTBALL: 7,
  GOLF_MENS: 8,
  GOLF_WOMENS: 9,
  GYMNASTICS_MENS: 10,
  GYMNASTICS_WOMENS: 11,
  ICE_HOCKEY_MENS: 12,
  ICE_HOCKEY_WOMENS: 13,
  ROWING_MENS: 14,
  ROWING_WOMENS: 15,
  SOCCER_MENS: 16,
  SOCCER_WOMENS: 17,
  SOFTBALL: 18,
  SWIMMINGDIVING_MENS: 19,
  SWIMMINGDIVING_WOMENS: 20,
  TENNIS_MENS: 21,
  TENNIS_WOMENS: 22,
  TRACK_AND_FIELD_MENS: 23,
  TRACK_AND_FIELD_WOMENS: 24,
  VOLLEYBALL_MENS: 25,
  VOLLEYBALL_WOMENS: 26,
  WRESTLING_MENS: 27,
  WRESTLING_WOMENS: 28,
  CHEERLEADING: 29,
  ENTERTAINMENT: 30,
  BUSINESS: 31,
  MEDIA: 32,
  TRAVEL: 33,
  EVENT: 34,
  OTHER: 35,
  ADMISSIONS: 36,
  NEW_TEAMS: 37,
  SPIRIT_PROGRAM: 38,
  POLO_MENS: 39,
  POLO_WOMENS: 40,
  CROSS_COUNTRY: 41,
  SQUASH_MENS: 42,
  SQUASH_WOMENS: 43,
  WHEELCHAIR_BASKETBALL: 44,
  GENERAL: 45,
  DANCE_TEAM: 46,
  SAILING_MENS: 47,
  SAILING_WOMENS: 48,
  INDOOR_TRACK_MENS: 49,
  INDOOR_TRACK_WOMENS: 50,
  INDOOR_TRACK: 51,
  OUTDOOR_TRACK: 52,
  RIFLE: 53,
  FENCING_MENS: 54,
  FENCING_WOMENS: 55,
  BADMINTON_MENS: 56,
  BADMINTON_WOMENS: 57,
  CURLING_MENS: 58,
  CURLING_WOMENS: 59,
  CURLING: 60,
  FASTPITCH: 61,
  FENCING: 62,
  FIGURE_SKATING: 63,
  MOUNTAIN_BIKING: 64,
  NORDIC_SKIING: 65,
  ROWING: 66,
  SYNCHRONIZED_SWIMMING_WOMENS: 67,
  RIFLE_MENS: 68,
  RIFLE_WOMENS: 69,
  BOWLING_MENS: 70,
  BOWLING_WOMENS: 71,
  SKIING_MENS: 72,
  SKIING_WOMENS: 73,
  EQUESTRIAN: 74,
  WATER_POLO_MENS: 75,
  WATER_POLO_WOMENS: 76,
  ALPINE_SKIING: 77,
  RODEO_MENS: 78,
  RODEO_WOMENS: 79,
  CLUB_HOCKEY: 80,
  SAAC: 81,
  RUGBY_MENS: 82,
  RUGBY_WOMENS: 83,
  CRICKET: 84,
  CYCLING: 85,
  SYNCHRONIZED_SWIMMING: 86,
  JV_BASKETBALL_MENS: 87,
  JV_BASKETBALL_WOMENS: 88,
  VOLLEYBALL_BEACH: 89,
  TRIATHLON: 90,
  ACROBATICS_TUMBLING: 91,
  LIGHTWEIGHT_ROWING_WOMENS: 92,
  CO_ED_SQUASH: 93,
  SYNCHRONIZED_SKATING: 94,
  LACROSSE_MENS: 95,
  LACROSSE_WOMENS: 96,
  SWIMMINGDIVING: 97,
  DIVING: 98,
  TRACK_AND_FIELD: 99,
  SKIING: 100,
  AUSTRALIAN_RULES_FOOTBALL_MENS: 101,
  AUSTRALIAN_RULES_FOOTBALL_WOMENS: 102
};
// packages/core/src/states.ts
var STATE_CODES = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FM",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PW",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
];
// packages/core/src/transactions.ts
var TRANSACTION_TYPES = {
  PUBLIC_APPEARANCE: 1,
  SOCIAL_MEDIA: 2,
  CAMPS_AND_LESSONS: 3,
  AUTOGRAPHS: 4,
  BUSINESS_OWNERSHIP_CREATION: 5,
  OUTSIDE_EMPLOYMENT: 6,
  REPRESENTATION_DISCLOSURE: 7,
  OTHER: 8,
  ROYALTY: 9,
  NOT_SURE: 10,
  COLLECTIVE: 11,
  EVENT_EXPERIENCE: 12,
  EARNED_MEDIA: 13,
  ENTERTAINMENT: 14,
  INFLUENCER: 15,
  IN_MARKET_APPEARANCE: 16,
  NASCAR_CONTENT: 17,
  FOUNDATION_HOF: 18,
  INDUSTRY_EVENT: 19,
  BROADCAST: 20,
  PARTNERSHIP: 21,
  IMPACT: 22,
  BRAND: 23,
  DRIVER_SUBMISSION: 24
};
var LEADERBOARD_ONLY_TRANSACTION_TYPE_IDS = [
  2,
  8,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24
];
var NON_LEADERBOARD_TRANSACTION_TYPE_IDS = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11
];
var EXCHANGE_STATUSES = {
  PROPOSED: 0,
  DECLINED: 1,
  APPROVED: 2,
  EXPIRED: 3,
  QUEUED: 4,
  PAYMENT_QUEUE_FAILED: 5,
  PAYMENT_PROCESSING: 30,
  PAYMENT_FAILED: 40,
  PAYMENT_COMPLETED: 50,
  PAYMENT_ON_HOLD: 60,
  TRANSFER_PROCESSING: 70,
  TRANSFER_FAILED: 80,
  TRANSFER_COMPLETE: 90,
  PAYOUT_PENDING: 100,
  PAYOUT_PROCESSING: 110,
  PAYOUT_FAILED: 120,
  PAYOUT_COMPLETED: 130,
  PAID_OUTSIDE_INFLCR: 140
};
var LEADERBOARD_STATUSES = {
  NOT_READY_FOR_REVIEW: 0,
  READY_FOR_REVIEW: 1,
  APPROVED: 2,
  REJECTED: 3
};
var TRANSACTION_UNIT_TYPES = {
  US_DOLLARS: 0,
  POINTS: 1
};
var TRANSACTION_TASK_STATUSES = {
  INCOMPLETE: 0,
  COMPLETE: 255
};
var TRANSACTION_PAYMENT_FEES = {
  ACH_PERCENTAGE_FEE: 0,
  CARD_FLAT_FEE: 1,
  CARD_PERCENTAGE_FEE: 2,
  PAYOUT_FLAT_FEE: 3,
  PAYOUT_INSTANT_PERCENTAGE_FEE: 4,
  PAYOUT_PERCENTAGE_FEE: 5
};
var PAYABLE_STATUSES = {
  CAN_PAY: 0,
  UNRESOLVED_TASKS: 1,
  AWAITING_SCHOOL: 2,
  AWAITING_ATHLETE: 3,
  ATHLETE_DECLINED: 4,
  ALREADY_PAID: 5,
  PAID_OUTSIDE_INFLCR: 6,
  NOT_PAYABLE: 7,
  EXPIRED: 8
};
var TRANSACTION_STATUSES = {
  PROPOSED: -1,
  SUBMITTED: 0,
  UPDATED: 1,
  FLAGGED: 2,
  APPROVED: 3,
  IN_REVIEW: 4,
  REVIEWED: 5
};
var TRANSACTION_REPORTING_METHODS = {
  SELF: 0,
  EXTERNAL: 1,
  THIRD_PARTY: 2,
  MPORT: 3,
  LOCAL_EXCHANGE: 4,
  GLOBAL_EXCHANGE: 5
};
var TRANSACTION_PAYMENT_TYPES = {
  CASH: 0,
  "PRODUCT/EQUITY": 1,
  POINTS: 2
};
// packages/core/src/websocket.ts
var DOWNLOAD_STATUSES = {
  pending: 0,
  in_progess: 1,
  finished: 2,
  failed: 3
};
var EVENT_KEYS = [
  "exchange.transaction.create.completed",
  "gallery.duplicate.completed",
  "gallery.duplicate.failed",
  "media.delete.complete",
  "media.delete.failed",
  "media.download.progress",
  "media.update.failed",
  "conversation.comment.created",
  "bulk.payment.completed"
];
export {
  inflcrErrorCodes,
  getRoleStr,
  WALLET_ONBOARDING_STATUSES,
  WALLET_ACCOUNT_TYPES,
  VERIFIED_PAYMENT_METHOD_STATUSES,
  TRANSACTION_UNIT_TYPES,
  TRANSACTION_TYPES,
  TRANSACTION_TASK_STATUSES,
  TRANSACTION_STATUSES,
  TRANSACTION_REPORTING_METHODS,
  TRANSACTION_PAYMENT_TYPES,
  TRANSACTION_PAYMENT_FEES,
  TAG_TYPES,
  TAG_STATUSES,
  STRIPE_PAYMENT_METHOD_PAYMENT_TYPES,
  STRIPE_ONBOARDING_STATUSES,
  STATE_CODES,
  SPORTS,
  SOCIAL_MEDIA_PLATFORM_IDS,
  SERVICE_PROVIDER_FEE_TYPES,
  SERVICE_PROVIDER_CATEGORIES,
  ROLES,
  PermissionRules,
  PER_PAGE_OPTIONS,
  PERMISSIONS,
  PAYMENT_GATEWAYS,
  PAYABLE_STATUSES,
  OPERATORS,
  NON_LEADERBOARD_TRANSACTION_TYPE_IDS,
  MEDIA_REQUEST_PURPOSE_TYPES,
  MEDIA_REQUEST_ATHLETE_STATUSES,
  MEDIA_MODEL_TYPES,
  MEDIA_FILE_TYPES,
  MEDIA_ACTIVITY_TYPES,
  MAJORS,
  LEADERBOARD_STATUSES,
  LEADERBOARD_ONLY_TRANSACTION_TYPE_IDS,
  LEADERBOARD_ONLY_BULLETIN_CATEGORY_IDS,
  INTERESTS,
  INTEGRATION_PROVIDER_KEYS,
  GALLERY_STATUSES,
  GALLERY_CATEGORIES,
  FEATURE_FLAGS,
  EXCHANGE_STATUSES,
  EXCHANGE_BRAND_USER_TYPES,
  EXCHANGE_BRAND_SCHOOL_STATUSES,
  EXCHANGE_BRAND_ENTITY_TYPES,
  EVENT_KEYS,
  DOWNLOAD_STATUSES,
  COUNTRY_CODES,
  CONTRACT_STATUSES,
  COMMENT_VISIBILITY_OPTIONS,
  BULLETIN_TYPES,
  BULLETIN_CATEGORIES,
  BRAND_STRATEGY_CATEGORIES,
  exports_apiV2 as ApiV2,
  exports_apiV1 as ApiV1,
  ATTESTATION_TYPES,
  APP_SWITCHER_SLUGS,
  AGREEMENT_STATUSES,
  AGENT_DISALLOWED_PERMISSIONS,
  ACADEMIC_YEARS
};

//# debugId=7C1193FC09CAF6F964756E2164756E21
